import React, { useState, useEffect } from "react";
// import "fullpage.js/vendors/scrolloverflow";
import ReactFullpage from "@fullpage/react-fullpage";
import "./style.css";
import Footer from "../../Components/Footer/Footer";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
const Customers = () => {
    const MySection = ({ content }) => {
        return <div className="section">{content}</div>;
    };
    // const anchors = ["firstPage", "secondPage", "thirdPage"];
    const [anchors, setAnchors] = useState(["", "", "", "", ""]);

    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    // const [mobile, setMobile] = useState(false);
    // useEffect(() => {
    //     var bodyWidth = document.querySelector("body").clientWidth;
    //     if (bodyWidth < 800) {
    //         setMobile(true);
    //     }
    // }, []);
    // const [lang, setLang] = useState("En");
    // useEffect(() => {
    //   if (localStorage.getItem("language") === "En") {
    //     setLang("En");
    //   } else if (localStorage.getItem("language") === "Fr") {
    //     setLang("Fr");
    //   }
    // }, []);

    return (
        <div className="custom">
            <ReactFullpage
                licenseKey={"YOUR_LICENSE_KEY"}
                anchors={anchors}
                navigation
                navigationTooltips={anchors}
                // sectionsColor={["#282c34", "#ff5f45", "#0798ec"]}
                onLeave={(origin, destination, direction) => {
                    console.log("onLeave event", {
                        origin,
                        destination,
                        direction,
                    });
                    if (destination.index == 2) {
                        document
                            .getElementById("g-1")
                            .classList.add("animate__fadeInUpBig");

                        document
                            .getElementById("g-2")
                            .classList.add("animate__fadeInUpBig");

                        document
                            .getElementById("g-3")
                            .classList.add("animate__fadeInUpBig");

                        document
                            .getElementById("g-4")
                            .classList.add("animate__fadeInUpBig");
                    } else if (destination.index == 3) {
                        document
                            .getElementById("3-1")
                            .classList.add("animate__fadeInUp");
                        document
                            .getElementById("3-1")
                            .classList.add("animate__delay-500ms");
                        document
                            .getElementById("3-2")
                            .classList.add("animate__fadeInLeft");
                        document
                            .getElementById("3-2")
                            .classList.add("animate__delay-1s");
                        document
                            .getElementById("3-3")
                            .classList.add("animate__fadeInUp");
                        document
                            .getElementById("3-3")
                            .classList.add("animate__delay-2s");
                        document
                            .getElementById("3-4")
                            .classList.add("animate__fadeInUp");
                        document
                            .getElementById("3-4")
                            .classList.add("animate__delay-2s");
                    } else if (destination.index == 4) {
                        document
                            .getElementById("m-1")
                            .classList.add("animate__zoomIn");
                    }
                }}
                render={({ state, fullpageApi }) => {
                    // console.log("render prop change", state, fullpageApi); // eslint-disable-line no-console

                    return (
                        <div>
                            {document.querySelector("body").clientWidth <
                            800 ? (
                                <>
                                    <MySection
                                        content={
                                            <div class="section overlay-container white">
                                                {/* <div class="background-page overlay-container"></div> */}
                                                <div class="container content box-middle text-center">
                                                    <div class="row vertical-row">
                                                        <h1 class="text-color">
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? "NOS CLIENTS"
                                                                : "Our Customers"}
                                                        </h1>
                                                        <div
                                                            class="col-md-4 col-sm-12 text-left"
                                                            data-aos="fade-right"
                                                            data-aos-duration="1500"
                                                        >
                                                            <h1 class="text">
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? "CE QUE NOUS AVONS À OFFRIR À NOS CLIENTS"
                                                                    : " What we have to offer for our customers"}
                                                            </h1>
                                                            <hr class="space m" />
                                                            <p>
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? `Il existe de nombreuses entreprises offrant de l’or à quiconque peut se permettre d’acheter.
                               Bien que l’abordabilité soit une qualité merveilleuse chez un acheteur, ce n’est pas le critère clé pour sélectionner nos clients. 
                               Gold Bar International a été configuré pour répondre aux besoins des clients les plus exclusifs au monde.`
                                                                    : ` There are many firms offering gold to anyone who can
                            afford to buy. While affordability is a wonderful
                            quality in a buyer, this is not the key criteria for
                            selecting our clients. Gold Bar International has
                            been configured to address the needs of the world’s
                            most exclusive clients.`}
                                                                <br />
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? `Il s’agit d’acheteurs qui souhaitent acquérir de grandes quantités d’or sur une base ponctuelle ou continue.`
                                                                    : `These are purchasers who wish to acquire large
                            quantities of gold on a spot or an ongoing basis.`}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <a href="#slide2">Down</a> */}
                                            </div>
                                        }
                                    />
                                    <MySection
                                        content={
                                            <div class="section overlay-container white">
                                                {/* <div class="background-page overlay-container"></div> */}
                                                {/* <div class="container content box-middle text-center">
                                                    <div class="row vertical-row"> */}
                                                {/* <h1 class="text-color">
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? "NOS CLIENTS"
                                                                : "Our Customers"}
                                                        </h1> */}

                                                <div
                                                    class="col-md-8 col-sm-12"
                                                    style={{
                                                        transform:
                                                            "translateY(-78px)",
                                                    }}
                                                >
                                                    <div class="row text-right">
                                                        <div
                                                            class="col-md-4 boxed boxed-border white middle-content border-color small-padding anima "
                                                            // data-aos="fade-up"
                                                            // data-aos-duration="2000"
                                                            style={{
                                                                width: "90%",
                                                                margin: "10px auto",
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? `Parmi nos clients privilégiés figurent les gouvernements, 
                                  les institutions financières, les utilisateurs finaux commerciaux et industriels,
                                   les gestionnaires de patrimoine et les particuliers fortunés.
                                    Ces groupes de clients cherchent à protéger la richesse, à créer de la richesse,
                                     à faciliter le mouvement de la richesse et/ou à créer des composants 
                                     et des produits finaux qui seront améliorés par l’or.`
                                                                    : ` Among our preferred clients are governments,
                                financial institutions, commercial and
                                industrial end-users, wealth managers, and high
                                net worth individuals. These client groups seek
                                to protect wealth, to build wealth, to
                                facilitate the movement of wealth, and/or to
                                create components and end-products that will be
                                enhanced by gold.`}
                                                            </p>
                                                        </div>

                                                        <div
                                                            class="col-md-4 boxed boxed-border white middle-content border-color small-padding anima"
                                                            // data-aos="fade-up"
                                                            // data-aos-duration="3000"
                                                            style={{
                                                                width: "90%",
                                                                margin: "auto",
                                                            }}
                                                        >
                                                            <p
                                                                style={{
                                                                    fontSize:
                                                                        "13px",
                                                                }}
                                                            >
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? `Nos partenaires souhaitent généralement acquérir de grandes quantités d’or
                                   sur une base ponctuelle ou continue. Parmi nos partenaires privilégiés figurent
                                    les gouvernements, les institutions financières, les utilisateurs finaux commerciaux et industriels,
                                     les gestionnaires de patrimoine et les Individuals.In valeur nette élevée en général,
                                      ces groupes de partenaires cherchent à protéger la richesse, à créer de la richesse,
                                       à faciliter le mouvement de la richesse et / ou à créer des composants et des produits finaux 
                                       qui seront améliorés par l’or. De plus, chaque groupe a ses propres objectifs uniques.`
                                                                    : `Our partners typically wish to acquire large
                                quantities of gold on a spot or an ongoing
                                basis. Among our preferred partners are
                                Governments, Financial Institutions, Commercial
                                and Industrial End-Users, Wealth Managers, and
                                High Net Worth Individuals.In general, these
                                partner groups seek to protect wealth, to build
                                wealth, to facilitate the movement of wealth,
                                and/or to create components and end-products
                                that will be enhanced by gold. Additionally,
                                each group has its own unique objectives.`}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {/* </div> */}
                                                    {/* </div> */}
                                                </div>
                                                {/* <a href="#slide2">Down</a> */}
                                            </div>
                                        }
                                    />
                                </>
                            ) : (
                                <MySection
                                    content={
                                        <div class="section overlay-container white">
                                            {/* <div class="background-page overlay-container"></div> */}
                                            <div class="container content box-middle text-center">
                                                <div class="row vertical-row">
                                                    <h1 class="text-color">
                                                        {localStorage.getItem(
                                                            "language"
                                                        ) === "Fr"
                                                            ? "NOS CLIENTS"
                                                            : "Our Customers"}
                                                    </h1>
                                                    <div
                                                        class="col-md-4 col-sm-12 text-left"
                                                        data-aos="fade-right"
                                                        data-aos-duration="1500"
                                                    >
                                                        <h1 class="text">
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? "CE QUE NOUS AVONS À OFFRIR À NOS CLIENTS"
                                                                : " What we have to offer for our customers"}
                                                        </h1>
                                                        <hr class="space m" />
                                                        <p>
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Il existe de nombreuses entreprises offrant de l’or à quiconque peut se permettre d’acheter.
                               Bien que l’abordabilité soit une qualité merveilleuse chez un acheteur, ce n’est pas le critère clé pour sélectionner nos clients. 
                               Gold Bar International a été configuré pour répondre aux besoins des clients les plus exclusifs au monde.`
                                                                : ` There are many firms offering gold to anyone who can
                            afford to buy. While affordability is a wonderful
                            quality in a buyer, this is not the key criteria for
                            selecting our clients. Gold Bar International has
                            been configured to address the needs of the world’s
                            most exclusive clients.`}
                                                            <br />
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Il s’agit d’acheteurs qui souhaitent acquérir de grandes quantités d’or sur une base ponctuelle ou continue.`
                                                                : `These are purchasers who wish to acquire large
                            quantities of gold on a spot or an ongoing basis.`}
                                                        </p>
                                                    </div>
                                                    <div class="col-md-8 col-sm-12">
                                                        <div class="row text-right">
                                                            <div
                                                                class="col-md-4 boxed boxed-border white middle-content border-color small-padding anima "
                                                                data-aos="fade-up"
                                                                data-aos-duration="2000"
                                                            >
                                                                <p>
                                                                    {localStorage.getItem(
                                                                        "language"
                                                                    ) === "Fr"
                                                                        ? `Parmi nos clients privilégiés figurent les gouvernements, 
                                  les institutions financières, les utilisateurs finaux commerciaux et industriels,
                                   les gestionnaires de patrimoine et les particuliers fortunés.
                                    Ces groupes de clients cherchent à protéger la richesse, à créer de la richesse,
                                     à faciliter le mouvement de la richesse et/ou à créer des composants 
                                     et des produits finaux qui seront améliorés par l’or.`
                                                                        : ` Among our preferred clients are governments,
                                financial institutions, commercial and
                                industrial end-users, wealth managers, and high
                                net worth individuals. These client groups seek
                                to protect wealth, to build wealth, to
                                facilitate the movement of wealth, and/or to
                                create components and end-products that will be
                                enhanced by gold.`}
                                                                </p>
                                                            </div>

                                                            <div
                                                                class="col-md-4 boxed boxed-border white middle-content border-color small-padding anima"
                                                                data-aos="fade-up"
                                                                data-aos-duration="3000"
                                                            >
                                                                <p>
                                                                    {localStorage.getItem(
                                                                        "language"
                                                                    ) === "Fr"
                                                                        ? `Nos partenaires souhaitent généralement acquérir de grandes quantités d’or
                                   sur une base ponctuelle ou continue. Parmi nos partenaires privilégiés figurent
                                    les gouvernements, les institutions financières, les utilisateurs finaux commerciaux et industriels,
                                     les gestionnaires de patrimoine et les Individuals.In valeur nette élevée en général,
                                      ces groupes de partenaires cherchent à protéger la richesse, à créer de la richesse,
                                       à faciliter le mouvement de la richesse et / ou à créer des composants et des produits finaux 
                                       qui seront améliorés par l’or. De plus, chaque groupe a ses propres objectifs uniques.`
                                                                        : `Our partners typically wish to acquire large
                                quantities of gold on a spot or an ongoing
                                basis. Among our preferred partners are
                                Governments, Financial Institutions, Commercial
                                and Industrial End-Users, Wealth Managers, and
                                High Net Worth Individuals.In general, these
                                partner groups seek to protect wealth, to build
                                wealth, to facilitate the movement of wealth,
                                and/or to create components and end-products
                                that will be enhanced by gold. Additionally,
                                each group has its own unique objectives.`}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <a href="#slide2">Down</a> */}
                                        </div>
                                    }
                                />
                            )}
                            {document.querySelector("body").clientWidth <
                            800 ? (
                                <MySection
                                    content={
                                        <>
                                            <div
                                                id="slide2"
                                                className="slide2Mobile"
                                            >
                                                <div className="section-gov">
                                                    <div class="gov-content">
                                                        <h1>
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `GOUVERNEMENTS`
                                                                : `   Governments`}
                                                        </h1>
                                                        <div class="border-b"></div>
                                                        <p class="text-u-gov">
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Ces clients sont motivés à acquérir des réserves d’or`
                                                                : `These clients are motivated to acquire gold
                              reserves`}
                                                        </p>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    id="g-1"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1500"
                                                                >
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Gold Bar International se distingue par la société que nous conservons. 
                                      Nous savons que nos partenaires du gouvernement et des institutions financières apprécient
                                       les transactions discrètes qui pourraient avoir des répercussions économiques et politiques importantes.`
                                                                            : ` Gold Bar International distinguishes itself
                                    by the company we keep. We know that our
                                    Government and Financial Institution
                                    partners value discrete transactions that
                                    could have significant economic and
                                    political implications.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1700"
                                                                    id="g-2"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `L’ampleur des transactions pour les banques
                                       centrales peut impliquer plusieurs milliards 
                                       de dollars et des millions de tonnes d’or. 
                                       Les réserves d’or peuvent aider à atténuer 
                                       le risque de change ainsi qu’à contrôler l’inflation
                                        et la croissance du marché - pour une stabilité 
                                        accrue dans une économie nationale.
`
                                                                            : ` The magnitude of the transactions for
                                    central banks can involve many billions of
                                    dollars and millions of tons of gold. Gold
                                    reserves can help mitigate currency risk as
                                    well as control inflation and market growth
                                    -- for increased stability in a national
                                    economy.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    id="g-3"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1900"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `L’or souverain fournit des garanties pour
                                       les transactions internationales et peut aider
                                        à résoudre les problèmes de balance commerciale.
                                         Gold Bar International peut faciliter les transactions
                                          de banque à banque au comptant et les contrats de production
                                           à long terme pour les nations souveraines et les banques.`
                                                                            : `Sovereign gold provides collateral for
                                    international transactions and can help
                                    address balance-of- trade issues. Gold Bar
                                    International can facilitate spot
                                    bank-to-bank transactions and long-term
                                    production contracts for sovereign nations
                                    and banks.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="2100"
                                                                    id="g-4"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Même les banques de détail nationales 
                                      et régionales ont besoin de ressources 
                                      fiables pour leurs clients qui apprécient 
                                      la commodité d’acheter de l’or localement. 
                                      Gold Bar International peut fournir des prix réduits
                                       plus élevés et des services de stockage
                                        pour vos clients des services bancaires de détail.`
                                                                            : ` Even national and regional retail banks need
                                    reliable resources for their customers who
                                    value the convenience of purchasing gold
                                    locally. Higher discount pricing and storage
                                    services can be provided by Gold Bar
                                    International for your retail banking
                                    customers.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Il convient de noter que Gold Bar International
                                       est affilié à la Bank of Makkah & Al Madinah,
                                        également basée à Londres. 
                                        La Banque dispose de pupitres de négociation 
                                        de métaux précieux et facilite les transactions pour notre société.`
                                                                            : `It should be noted that Gold Bar
                                    International is affiliated with the Bank of
                                    Makkah & Al Madinah, also headquartered in
                                    London. The Bank has precious metal trading
                                    desks and facilitates the transactions for
                                    our firm.`}
                                                                        <br />
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Renforcer les réserves de change :`
                                                                                : `To Bolster Foreign Reserves:`}
                                                                        </b>{" "}
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `20 % de l’or jamais extrait est entre les mains de réserves centrales`
                                                                            : ` 20% of gold ever mined is in the hands of
                                    central reserves.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        {" "}
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Gérer et atténuer les risques : `
                                                                                : `To Manage and Mitigate Risk:`}
                                                                        </b>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Souvent, les banques centrales achètent de l’or 
                                      et d’autres métaux précieux pour éviter les risques
                                       de change et contrôler l’inflation. 
                                      Le pouvoir d’achat de l’or a tendance à agir comme
                                       une couverture contre un dollar affaibli ou toute autre monnaie fiduciaire.`
                                                                            : `
                                     Frequently, central banks buy gold and other
                                    precious metals to avoid currency risks and
                                    to control inflation. The buying power of
                                    gold tends to act as a hedge against a
                                    weakening dollar or any other fiat currency.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Assurer la stabilité et la croissance: `
                                                                                : `To Ensure Stability and Growth:`}
                                                                        </b>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `La capacité d’acheter et de vendre de l’or aide
                                       les banques centrales à contrôler la croissance du marché.
                                        Posséder de l’or empêche ces excès de stimuler la monnaie 
                                        et de nuire à l’industrie.`
                                                                            : `
                                    The ability to buy and sell gold helps
                                    central banks control market growth. Owning
                                    gold prevents these excesses from driving
                                    currency and damaging industry.`}
                                                                        <br />
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Pour répondre aux demandes des clients particuliers de la Banque : `
                                                                                : `To Meet the Demands of The Bank’s Retail
                                      Customers:`}
                                                                        </b>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Les clients de la Banque bénéficient de la 
                                      commodité d’acheter des pièces d’or en tant que
                                       collectionneurs (« numismates ») et des bouillons
                                        en tant qu’investisseurs directement auprès de leurs banques locales.`
                                                                            : ` Bank customers enjoy the convenience of
                                    purchasing gold coins as collectors
                                    (“numismatists”) and bouillon as investors
                                    directly from their local banks.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Gold Bar International est affilié à 
                                      la Bank of Makkah & Al Madinah, également 
                                      basée à Londres. La Banque dispose d’un bureau 
                                      de négociation de métaux précieux et facilite les
                                       transactions pour Gold Bar International.`
                                                                            : ` Gold Bar International is affiliated with
                                    the Bank of Makkah & Al Madinah, also
                                    headquartered in London. The Bank has a
                                    precious metals trading desk and facilitates
                                    the transactions for Gold Bar International.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                />
                            ) : (
                                <MySection
                                    content={
                                        <>
                                            <div
                                                id="slide2"
                                                className="slide2Web"
                                            >
                                                <div className="section-gov">
                                                    <div class="gov-content">
                                                        <h1>
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `GOUVERNEMENTS`
                                                                : `   Governments`}
                                                        </h1>
                                                        <div class="border-b"></div>
                                                        <p class="text-u-gov">
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Ces clients sont motivés à acquérir des réserves d’or`
                                                                : `These clients are motivated to acquire gold
                              reserves`}
                                                        </p>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    id="g-1"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1500"
                                                                >
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Gold Bar International se distingue par la société que nous conservons. 
                                      Nous savons que nos partenaires du gouvernement et des institutions financières apprécient
                                       les transactions discrètes qui pourraient avoir des répercussions économiques et politiques importantes.`
                                                                            : ` Gold Bar International distinguishes itself
                                    by the company we keep. We know that our
                                    Government and Financial Institution
                                    partners value discrete transactions that
                                    could have significant economic and
                                    political implications.`}{" "}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1700"
                                                                    id="g-2"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `L’ampleur des transactions pour les banques
                                       centrales peut impliquer plusieurs milliards 
                                       de dollars et des millions de tonnes d’or. 
                                       Les réserves d’or peuvent aider à atténuer 
                                       le risque de change ainsi qu’à contrôler l’inflation
                                        et la croissance du marché - pour une stabilité 
                                        accrue dans une économie nationale.
`
                                                                            : ` The magnitude of the transactions for
                                    central banks can involve many billions of
                                    dollars and millions of tons of gold. Gold
                                    reserves can help mitigate currency risk as
                                    well as control inflation and market growth
                                    -- for increased stability in a national
                                    economy.`}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    id="g-3"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="1900"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `L’or souverain fournit des garanties pour
                                       les transactions internationales et peut aider
                                        à résoudre les problèmes de balance commerciale.
                                         Gold Bar International peut faciliter les transactions
                                          de banque à banque au comptant et les contrats de production
                                           à long terme pour les nations souveraines et les banques.`
                                                                            : `Sovereign gold provides collateral for
                                    international transactions and can help
                                    address balance-of- trade issues. Gold Bar
                                    International can facilitate spot
                                    bank-to-bank transactions and long-term
                                    production contracts for sovereign nations
                                    and banks.`}
                                                                    </p>
                                                                </div>
                                                                <div
                                                                    class="gov-card animate__animated"
                                                                    // data-aos="zoom-in"
                                                                    // data-aos-duration="2100"
                                                                    id="g-4"
                                                                >
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Même les banques de détail nationales 
                                      et régionales ont besoin de ressources 
                                      fiables pour leurs clients qui apprécient 
                                      la commodité d’acheter de l’or localement. 
                                      Gold Bar International peut fournir des prix réduits
                                       plus élevés et des services de stockage
                                        pour vos clients des services bancaires de détail.`
                                                                            : ` Even national and regional retail banks need
                                    reliable resources for their customers who
                                    value the convenience of purchasing gold
                                    locally. Higher discount pricing and storage
                                    services can be provided by Gold Bar
                                    International for your retail banking
                                    customers.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="slide align-items-center">
                                                            <div class="gov-cards">
                                                                <div class="gov-card">
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Il convient de noter que Gold Bar International
                                       est affilié à la Bank of Makkah & Al Madinah,
                                        également basée à Londres. 
                                        La Banque dispose de pupitres de négociation 
                                        de métaux précieux et facilite les transactions pour notre société.`
                                                                            : `It should be noted that Gold Bar
                                    International is affiliated with the Bank of
                                    Makkah & Al Madinah, also headquartered in
                                    London. The Bank has precious metal trading
                                    desks and facilitates the transactions for
                                    our firm.`}
                                                                        <br />
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Renforcer les réserves de change :`
                                                                                : `To Bolster Foreign Reserves:`}
                                                                        </b>{" "}
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `20 % de l’or jamais extrait est entre les mains de réserves centrales`
                                                                            : ` 20% of gold ever mined is in the hands of
                                    central reserves.`}
                                                                    </p>
                                                                </div>
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        {" "}
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Gérer et atténuer les risques : `
                                                                                : `To Manage and Mitigate Risk:`}
                                                                        </b>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Souvent, les banques centrales achètent de l’or 
                                      et d’autres métaux précieux pour éviter les risques
                                       de change et contrôler l’inflation. 
                                      Le pouvoir d’achat de l’or a tendance à agir comme
                                       une couverture contre un dollar affaibli ou toute autre monnaie fiduciaire.`
                                                                            : `
                                     Frequently, central banks buy gold and other
                                    precious metals to avoid currency risks and
                                    to control inflation. The buying power of
                                    gold tends to act as a hedge against a
                                    weakening dollar or any other fiat currency.`}
                                                                    </p>
                                                                </div>
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Assurer la stabilité et la croissance: `
                                                                                : `To Ensure Stability and Growth:`}{" "}
                                                                        </b>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `La capacité d’acheter et de vendre de l’or aide
                                       les banques centrales à contrôler la croissance du marché.
                                        Posséder de l’or empêche ces excès de stimuler la monnaie 
                                        et de nuire à l’industrie.`
                                                                            : `
                                    The ability to buy and sell gold helps
                                    central banks control market growth. Owning
                                    gold prevents these excesses from driving
                                    currency and damaging industry.`}
                                                                        <br />
                                                                        <b>
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `Pour répondre aux demandes des clients particuliers de la Banque : `
                                                                                : `To Meet the Demands of The Bank’s Retail
                                      Customers:`}
                                                                        </b>{" "}
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Les clients de la Banque bénéficient de la 
                                      commodité d’acheter des pièces d’or en tant que
                                       collectionneurs (« numismates ») et des bouillons
                                        en tant qu’investisseurs directement auprès de leurs banques locales.`
                                                                            : ` Bank customers enjoy the convenience of
                                    purchasing gold coins as collectors
                                    (“numismatists”) and bouillon as investors
                                    directly from their local banks.`}
                                                                    </p>
                                                                </div>
                                                                <div class="gov-card">
                                                                    {" "}
                                                                    <p>
                                                                        {localStorage.getItem(
                                                                            "language"
                                                                        ) ===
                                                                        "Fr"
                                                                            ? `Gold Bar International est affilié à 
                                      la Bank of Makkah & Al Madinah, également 
                                      basée à Londres. La Banque dispose d’un bureau 
                                      de négociation de métaux précieux et facilite les
                                       transactions pour Gold Bar International.`
                                                                            : ` Gold Bar International is affiliated with
                                    the Bank of Makkah & Al Madinah, also
                                    headquartered in London. The Bank has a
                                    precious metals trading desk and facilitates
                                    the transactions for Gold Bar International.`}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                />
                            )}
                            <MySection
                                content={
                                    <div className="c-i">
                                        <div className="c-i-content">
                                            <h2>
                                                {localStorage.getItem(
                                                    "language"
                                                ) === "Fr"
                                                    ? `UTILISATIONS DE L’OR AUX ÉTATS-UNIS`
                                                    : ` Uses of Gold in the United States`}
                                            </h2>
                                            <div className="ci-cards">
                                                <div
                                                    className="ci-card animate__animated first-card"
                                                    id="3-1"
                                                >
                                                    <p>
                                                        {localStorage.getItem(
                                                            "language"
                                                        ) === "Fr"
                                                            ? `Gold Bar International peut être votre ressource
                               intégrée verticalement pour simplifier votre chaîne
                                d’approvisionnement, réduire les coûts et maintenir 
                                vos lignes de production en fonctionnement. 
                                Avec plus de 30 mines sous contrat et notre propre portefeuille de raffineries,
                                 la fiabilité est améliorée et les exigences de production personnalisées sont 
                                 plus facilement satisfaites. Pouvons-nous avoir un appel individuel pour évaluer
                                  vos besoins et vos priorités?`
                                                            : `Gold Bar International can be your vertically
                            integrated resource to simplify your supply chain,
                            reduce costs and keep your production lines running.
                            With more than 30 mines under contract, and our own
                            portfolio of refineries, reliability is improved,
                            and custom production requirements are more easily
                            met. May we have a one-on-one call to assess your
                            needs and priorities?`}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="c-i-chart ">
                                                <img
                                                    src={require("../../Assets/stat.png")}
                                                    alt="chart"
                                                    className="animate__animated"
                                                    id="3-2"
                                                />
                                                <div className="chart-description">
                                                    <div
                                                        className="chart animate__animated"
                                                        id="3-3"
                                                    >
                                                        <p>
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Ce graphique circulaire montre comment l’or a 
                                été utilisé aux États-Unis en 2019, sans compter 
                                les lingots d’or. Les principales utilisations étaient
                                 dans la bijouterie (50%) et l’électronique (37%). 
                                 La frappe des pièces officielles représentait 8% de l’or utilisé,
                                  et 5% était destiné à d’autres utilisations, notamment médicales, 
                                  aérospatiales, de décoration et de verrerie. Données des résumés 
                                  des produits minéraux de l’USGS pour 2019.`
                                                                : `This pie chart shows how gold was used in the
                              United States in 2019, not including gold bullion.
                              The main uses were in jewelry (50%) and
                              electronics (37%). The minting of official coins
                              accounted for 8% of the gold used, and 5% was for
                              other uses including medical, aerospace,
                              decoration and glassmaking. Data from the USGS
                              Mineral Commodity Summaries for 2019.`}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className="chart animate__animated"
                                                        id="3-4"
                                                    >
                                                        <p>
                                                            {localStorage.getItem(
                                                                "language"
                                                            ) === "Fr"
                                                                ? `Veuillez vous référer à la section Marché 
                                de l’or pour plus de détails sur les applications
                                 de l’or (ainsi que les tendances et les prévisions du marché).
                                  Gold Bar International comprend que pour toute entreprise,
                                   les matériaux qui contribuent au produit fini doivent provenir
                                    de fournisseurs qui offrent la bonne combinaison de prix, 
                                    de qualité, de fiabilité et de soutien logistique. 
                                    Peu importe la beauté de l’or, s’il n’arrive pas à temps, 
                                    dans le budget et selon les spécifications, les lignes de
                                     production peuvent être fermées avec des conséquences coûteuses.`
                                                                : `Please refer to the Gold Market section for
                              greater detail on gold applications (as well as
                              market trends and forecasts). Gold Bar
                              International understands that for any business,
                              the materials that contribute to the finished
                              product must come from suppliers that offer the
                              right combination of price, quality, reliability
                              and logistical support. No matter how beautiful
                              the gold, if it does not arrive on time, on budget
                              and on spec, production lines can be shut down
                              with costly consequences.`}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            />
                            <MySection
                                content={
                                    <div className="wealth-management">
                                        <h2>
                                            {localStorage.getItem(
                                                "language"
                                            ) === "Fr"
                                                ? `LES GENS ACHÈTENT DE L’OR PHYSIQUE POUR DE NOMBREUSES RAISONS`
                                                : `People buy physical gold for many reasons`}
                                        </h2>
                                        <div
                                            className="slide"
                                            style={{
                                                transform: "translateY(-55px)",
                                            }}
                                        >
                                            <div
                                                className="management-quotes animate__animated "
                                                id="m-1"
                                            >
                                                <i class="fas fa-quote-right"></i>
                                                <p>
                                                    {localStorage.getItem(
                                                        "language"
                                                    ) === "Fr"
                                                        ? `Protégez-vous contre les pertes dans d’autres catégories d’actifs,
                             pour la sécurité en temps de crise et parce que l’or est un actif tangible,
                              liquide et privé. Étant donné que l’or a toujours été une « solution » 
                              fiable en période de difficultés financières et qu’il est moins volatil en tant qu’actif,
                               l’or est considéré comme une option d’investissement sûre et à faible risque, en particulier
                                en période d’incertitude, par rapport à d’autres investissements tels que les actions.`
                                                        : `Protect against losses in other asset categories, for
                          security in times of crisis, and because gold is a
                          tangible, liquid, and a private asset. Since gold has
                          always been a reliable “solution” during financial
                          hardships and is less volatile as an asset, gold is
                          considered a low-risk, safe investment
                          option—especially during uncertain times—as compared
                          to other investments such as stocks.`}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className="slide"
                                            style={{
                                                transform: "translateY(-55px)",
                                            }}
                                        >
                                            <div className="management-quotes">
                                                <i class="fas fa-quote-right"></i>
                                                <p>
                                                    {localStorage.getItem(
                                                        "language"
                                                    ) === "Fr"
                                                        ? `Les organisations de gestion de patrimoine et leurs clients,
                             les particuliers fortunés, apprécieront l’approvisionnement direct
                              et les autres services de soutien que Gold Bar International peut fournir.
                               En plus des garanties de qualité, des programmes de rachat, du stockage en 
                               chambre forte et des services logistiques, Gold Bar International offrira des
                                prix avantageux par rapport à l’indice du marché LME.`
                                                        : `Wealth Management organizations and their clients,
                          High Net Worth Individuals, will appreciate the direct
                          sourcing and other support services that Gold Bar
                          International can provide. In addition to Quality
                          Guarantees, Buy-Back Programs, Vault Storage and
                          Logistical Services, Gold Bar International will
                          provide advantageous pricing versus the LME market
                          index.`}
                                                </p>
                                            </div>
                                        </div>
                                        <div
                                            className="slide"
                                            style={{
                                                transform: "translateY(-55px)",
                                            }}
                                        >
                                            <div className="management-quotes">
                                                <i class="fas fa-quote-right"></i>
                                                <p>
                                                    {localStorage.getItem(
                                                        "language"
                                                    ) === "Fr"
                                                        ? `Nous pouvons même fournir des portails de site Web 
                            « 24 Karat Triple-Lock Secured » pour nos partenaires de
                             gestion de patrimoine et de valeur nette élevée. 
                             Gestionnaires de patrimoine, veuillez nous appeler afin que
                              nous puissions vous aider à rendre votre avenir - et l’avenir 
                              de vos clients fortunés - encore plus « dorés».`
                                                        : `We can even provide “24 Karat Triple-Lock Secured“
                          website portals for our Wealth Management and High Net
                          Worth partners. Wealth Managers, please give us a call
                          so we can help make your future -- and the future of
                          your High-Net-Worth Clients-- even more “golden.”`}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            />
                            {document.querySelector("body").clientWidth <
                            800 ? (
                                <MySection
                                    content={
                                        <div
                                            class="footer-section section"
                                            style={{
                                                backgroundColor: "#242424",
                                            }}
                                        >
                                            <div>
                                                <div class="container">
                                                    <div class="footer-widget-wrap">
                                                        <div class="row">
                                                            <div class="col-lg-4 col-sm-6">
                                                                <div class="footer-widget widget-about">
                                                                    <a
                                                                        class="footer-logo"
                                                                        href="index.html"
                                                                    >
                                                                        <img
                                                                            src={require("../../Assets/logo.png")}
                                                                            alt="Logo"
                                                                            width="200px"
                                                                        />
                                                                    </a>
                                                                    <div class="widget-info">
                                                                        <ul>
                                                                            <li class="">
                                                                                71
                                                                                -75
                                                                                Shelton
                                                                                Street,
                                                                                Covent
                                                                                Garden,
                                                                                London,
                                                                                WC2H
                                                                                9JQ,
                                                                                Great
                                                                                Britain{" "}
                                                                            </li>
                                                                            <li>
                                                                                info@goldbarint.com
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div class="footer-social">
                                                                        <ul class="social">
                                                                            <li>
                                                                                <a href="#">
                                                                                    <i class="fab fa-facebook-f"></i>
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="#">
                                                                                    <i class="fab fa-twitter"></i>
                                                                                </a>
                                                                            </li>
                                                                            <li>
                                                                                <a href="#">
                                                                                    <i class="fab fa-linkedin-in"></i>
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="footer-section-m">
                                                                <div class="col-lg-4 col-sm-6">
                                                                    <div class="footer-widget ">
                                                                        <h4 class="footer-widget-title">
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `LIENS UTILES`
                                                                                : `Useful Links`}
                                                                        </h4>
                                                                        <div class="widget-link">
                                                                            <ul class="link">
                                                                                <li>
                                                                                    <Link to="/procedures">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Procédures`
                                                                                            : `Procedures`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/about-us">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `À propos de l’entreprise`
                                                                                            : `About Company`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/customers">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Clientèle`
                                                                                            : `Customers`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/contact-us">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Contactez-nous`
                                                                                            : `Contact Us`}{" "}
                                                                                    </Link>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-lg-4 col-sm-6">
                                                                    <div class="footer-widget">
                                                                        <h4 class="footer-widget-title">
                                                                            {localStorage.getItem(
                                                                                "language"
                                                                            ) ===
                                                                            "Fr"
                                                                                ? `NOS SERVICES`
                                                                                : `Our Services`}
                                                                        </h4>
                                                                        <div class="widget-link">
                                                                            <ul class="link">
                                                                                <li>
                                                                                    <Link to="/products-services">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Produit En Or`
                                                                                            : `Gold Product`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/products-services">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Quantités d’or`
                                                                                            : `Gold Quantities`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/products-services">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Prix de l’or`
                                                                                            : `Gold Pricing`}
                                                                                    </Link>
                                                                                </li>
                                                                                <li>
                                                                                    <Link to="/products-services">
                                                                                        {localStorage.getItem(
                                                                                            "language"
                                                                                        ) ===
                                                                                        "Fr"
                                                                                            ? `Livraison de
produits/Logistique`
                                                                                            : `Product Delivery/Logistics`}
                                                                                    </Link>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    class="footer-copyright"
                                                    style={{
                                                        background: "#14151e",
                                                    }}
                                                >
                                                    <div class="container">
                                                        <div class="copyright-text text-center">
                                                            <p>
                                                                ©{" "}
                                                                {localStorage.getItem(
                                                                    "language"
                                                                ) === "Fr"
                                                                    ? `Copyrights 2022 Gold Bar Tous droits réservés.`
                                                                    : `Copyrights 2022 Gold Bar All rights reserved.`}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                />
                            ) : (
                                <MySection content={<Footer />} />
                            )}
                        </div>
                    );
                }}
            />
        </div>
    );
};

export default Customers;
